const EvolutionIntegrations = ({ apiClient }) => ({
  createInstance() {
    return apiClient.post('integrations/evolution-api/')
  },

  generateQRCode(instanceName) {
    return apiClient.get(`integrations/evolution-api/${instanceName}`)
  },

  deleteInstance(instanceName) {
    return apiClient.delete(`integrations/evolution-api/${instanceName}`)
  },
})

export default EvolutionIntegrations
